var render = function render(){var _vm=this,_c=_vm._self._c;return _c('JoszakiButton',_vm._b({staticClass:"relative"},'JoszakiButton',_vm.$attrs,false),[_c('input',{staticClass:"absolute opacity-0 top-0 right-0 left-0 bottom-0 cursor-pointer",attrs:{"type":"file","multiple":_vm.allowMultiple,"accept":_vm.accept},on:{"change":_vm.changeHandler}}),_vm._v(" "+_vm._s(_vm.label)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }